import { render, staticRenderFns } from "./ImportacoesObjetos.vue?vue&type=template&id=259e4ccf&scoped=true&"
import script from "./ImportacoesObjetos.vue?vue&type=script&lang=js&"
export * from "./ImportacoesObjetos.vue?vue&type=script&lang=js&"
import style0 from "./ImportacoesObjetos.vue?vue&type=style&index=0&id=259e4ccf&prod&lang=scss&scoped=true&"
import style1 from "./ImportacoesObjetos.vue?vue&type=style&index=1&id=259e4ccf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259e4ccf",
  null
  
)

export default component.exports